import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ContentEditableText } from 'modules/campaigns/components/ContentEditableText/ContentEditableText';
import {
    creativeDescriptionValidations,
    useInsignificantChangesValidation,
} from 'modules/campaigns/config/validations/creative';
import {
    DESCRIPTION_WARNING_THRESHOLD,
    MAX_DESCRIPTION_LENGTH,
} from 'modules/campaigns/modules/creative-creator/components/ContentField/config';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';

export const DESCRIPTION_FIELD_ID = 'description';

export const ContentDescription = ({
    id,
    field = DESCRIPTION_FIELD_ID,
    placeholder,
    autoFocus,
    validations = creativeDescriptionValidations,
    validationDependencies,
    ...rest
}) => {
    const isContentValidationEnabled = useConfigMatch({
        [FEATURE_FLAGS.AUTO_REVIEWER_CONTENT_VALIDATIONS_ENABLED]: 'true',
    });

    const {
        formAccount: { accountId },
        isInitialRecommendationsReady,
    } = useFormDataContext();

    const finalValidations = useInsignificantChangesValidation({ baseValidations: validations });

    const maxDescriptionLength = MAX_DESCRIPTION_LENGTH;

    const finalValidationDependencies = useMemo(
        () => ({
            isContentValidationEnabled,
            accountId,
            maxDescriptionLength,
            ...validationDependencies,
        }),
        [isContentValidationEnabled, accountId, maxDescriptionLength, validationDependencies]
    );

    return (
        <ContentEditableText
            id={id}
            field={field}
            autoFocus={autoFocus}
            placeholder={placeholder}
            hideDeleteButton
            validations={finalValidations}
            validationDependencies={finalValidationDependencies}
            maxLength={MAX_DESCRIPTION_LENGTH}
            warningThreshold={DESCRIPTION_WARNING_THRESHOLD}
            isFormReady={isInitialRecommendationsReady}
            {...rest}
        />
    );
};

ContentDescription.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.node,
    autoFocus: PropTypes.bool,
};
